import React from 'react';

import cx from 'classnames';
import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';

import { getItineraryNavLinks, getTitleId } from 'components/Pages/Admin/Page/Landing/utils';
import LandingPagesContainer, { LANDING_PAGES_CONTAINER_ID } from 'components/shared/LandingPage/components/Grid';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { useCustomStyles, useCustomFonts } from 'hooks/useCustomFront';
import { useScrollLandingToTop } from 'hooks/useScrollLandingToTop';
import { useScrollOffset } from 'hooks/useScrollOffset';

import s from './index.module.css';
import ItineraryLandingPage from './ItineraryLandingPage';

const useWebViewScroll = (pages = [], landingTheme) => {
  const { search } = useLocation();

  const { clickOffset } = useScrollOffset({ landingTheme, isItinerariesItem: true });

  React.useEffect(() => {
    if (new URLSearchParams(search).get('webview') !== 'true') return;

    const handleScrollToAnchor = () => {
      const anchor = new URLSearchParams(search).get('block_id') ?? window.location.hash.substring(1);

      if (!anchor) return;
      const targetPageIndex = pages.findIndex((page) => page.id === Number(anchor));

      if (targetPageIndex === -1) return;
      const targetPage = pages[targetPageIndex];

      const targetLink = getTitleId(targetPage.headline, targetPageIndex);

      setTimeout(() => {
        scroller.scrollTo(targetLink, {
          containerId: LANDING_PAGES_CONTAINER_ID,
          smooth: true,
          duration: 200,
          offset: clickOffset(targetPageIndex === 0),
        });
      });
    };

    handleScrollToAnchor();
    window.history.replaceState({}, '', window.location.pathname + window.location.search);
  }, []);
};

function ItineraryLandingPages(props) {
  useScrollLandingToTop();
  const {
    pages: rawPages,
    itineraryItem,
    withNavHeader,
    extraHeaderOptionsLandingPageContext,
    isPrivate,
    manageHideCostsPermission,
    landingTheme,
    className,
    itinerariesItemType,
  } = props;

  const customStylesTargetItem =
    itinerariesItemType === ITINERARIES_ITEM_TYPES.GUEST_PORTAL ? itineraryItem.itinerary : itineraryItem;
  useCustomStyles({ css: customStylesTargetItem?.customStyles, customId: customStylesTargetItem.id });
  useCustomFonts({ landingItem: customStylesTargetItem, customId: customStylesTargetItem.id });
  const pages = rawPages
    .map((page) => {
      if (!page.title) {
        return { ...page, title: page.headline };
      }

      return page;
    })
    .filter((page) => !page.hidden && !page.empty);
  const navLinks = getItineraryNavLinks(pages);

  useWebViewScroll(pages, landingTheme);

  return (
    <LandingPagesContainer
      className={cx(
        s.landingPagesContext,
        withNavHeader && s.landingPagesContextWithNavHeader,
        `custom-main-${landingTheme}`,
        className,
      )}
    >
      {/*{!isTabletOrMobile && (*/}
      {/*  <NavNotch*/}
      {/*    landingTheme={landingTheme}*/}
      {/*    links={navLinks}*/}
      {/*    isPortalItinerary*/}
      {/*    className={cx(withNavHeader && s.notchWithNavHeader)}*/}
      {/*  />*/}
      {/*)}*/}
      {pages.map((page, i) => (
        <ItineraryLandingPage
          key={i}
          landingData={page}
          anchor={navLinks[i]}
          screens={navLinks}
          pageIndex={i}
          page={itineraryItem}
          isLastPage={i === pages.length - 1}
          isPrivate={isPrivate}
          manageHideCostsPermission={manageHideCostsPermission}
          extraHeaderOptionsLandingPageContext={extraHeaderOptionsLandingPageContext}
          landingTheme={landingTheme}
        />
      ))}
    </LandingPagesContainer>
  );
}

export default ItineraryLandingPages;
